module.exports = __webpack_public_path__ + "img/menuSp.978ea510.svg";